export default {"src":"/_next/static/media/cn-logo-light.ef80c15b.svg","height":32,"width":201,"blurWidth":0,"blurHeight":0};